import React from 'react';
import {
  ViewButton,
  EditButton,
  ImpersonateButton,
} from '../Common/DataTable/tableActionButtons';
import {
  getFilter,
  getLabels,
  getSort,
} from '../Common/DataTable/tableHelpers';
import moment from 'moment';
import FromNow from '../Common/FromNow';
import roles from '../../config/roles';
import assignAllowedRoles from '../../config/assignAllowedRoles';

const createTableColumns = (
  openViewModal,
  openEditModal,
  handleImpersonateUser,
  acquisitionOrders,
  user,
  countryId,
  isImpersonating,
) => [
  {
    title: 'ID',
    name: 'id',
    hidden: true,
  },
  {
    title: 'Display Name',
    name: 'displayName',
    width: 150,
    sort: true,
  },
  {
    title: 'Role',
    name: 'role',
    width: 120,
    sort: true,
  },
  {
    title: 'Exchange Number',
    name: 'phoneExchangeId',
    width: 150,
    sort: true,
  },
  {
    title: 'Acquisition Orders',
    name: 'acquisitionOrderIds',
    getCellValue: (row) =>
      getLabels(row.acquisitionOrderIds?.[countryId], acquisitionOrders),
  },
  {
    title: 'Active',
    name: 'active',
    width: 100,
    formatterComponent: ({ value }) =>
      value ? (
        <span className="badge badge-success font-size-12">YES</span>
      ) : (
        <span className="badge badge-danger font-size-12">NO</span>
      ),
    filter: (value, filter) => getFilter(value ? 'yes' : 'no', filter.value),
    sorting: (a, b) => getSort(a ? 'yes' : 'no', b ? 'yes' : 'no'),
  },
  {
    title: 'Created At',
    name: 'createdAt',
    width: 120,
    formatterComponent: ({ value }) => <FromNow value={value} />,
    sorting: (a, b) => getSort(moment(a).valueOf(), moment(b).valueOf()),
    filter: (value, filter) =>
      getFilter(`${moment(value).fromNow()}`, filter.value),
  },
  {
    title: 'Action',
    name: 'action',
    width: 180,
    align: 'center',
    formatterComponent: ({ row }) => {
      const allowedRoles = assignAllowedRoles[user.role] ?? [];
      const canImpersonate =
        !isImpersonating &&
        allowedRoles.includes(row.role) &&
        row.role !== user.role &&
        row.active &&
        user.id !== row.id;

      return (
        <ul className="list-inline font-size-20 contact-links mb-0">
          <ViewButton row={row} onPress={openViewModal} />
          {(user.role !== row.role || user.id === row.id) && (
            <EditButton row={row} onPress={openEditModal} />
          )}
          {canImpersonate && (
            <ImpersonateButton row={row} onPress={handleImpersonateUser} />
          )}
        </ul>
      );
    },
    filter: 'disabled',
    sorting: 'disabled',
  },
];

export default createTableColumns;
